import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./GraveDetailsUser.css";

// Normalizes Arabic characters for better search matching
const normalizeString = (str) => {
  return str
    .replace(/[\u0621\u0622\u0623\u0624\u0625\u0626]/g, "ا")
    .replace(/[\u064A\u0649]/g, "ي")
    .replace(/[\u064E\u0650\u0652\u064B\u064C\u064D]/g, "");
};

export default function GraveDetailsUser() {
  const { graveId } = useParams();
  const [graveDetails, setGraveDetails] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchGraveDetails = async () => {
      try {
        const response = await fetch(
          `https://cemetery-management.vercel.app/api/graves/graves/${graveId}`
        );
        const data = await response.json();
        setGraveDetails(data);
      } catch (error) {
        console.error("Error fetching grave details:", error);
      }
    };
    fetchGraveDetails();
  }, [graveId]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("ar-EG", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Filter and sort buriedPersons based on search term and burial date (latest first)
  const filteredBuriedPersons =
    graveDetails?.buriedPersons
      .filter((person) =>
        normalizeString(person.name).includes(normalizeString(searchTerm))
      )
      .sort((a, b) => new Date(b.burialDate) - new Date(a.burialDate)) || [];

  if (!graveDetails) {
    return <p>Loading...</p>;
  }

  return (
    <div className="grave-details-container">
      <h2 className="grave-details-title">تفاصيل المقبرة {graveDetails.number}</h2>

      {/* Search Input */}
      <input
        type="text"
        placeholder="ابحث عن اسم المتوفي...."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />

      <table className="grave-details-table">
        <thead>
          <tr>
            <th>الاسم</th>
            <th>تاريخ الدفن</th>
          </tr>
        </thead>
        <tbody>
          {filteredBuriedPersons.map((person, index) => (
            <tr key={index}>
              <td>{person.name}</td>
              <td>{formatDate(person.burialDate)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {filteredBuriedPersons.length === 0 && (
        <p className="no-results-message">لا توجد نتائج مطابقة للبحث.</p>
      )}
    </div>
  );
}
